import toastr from 'react-hot-toast';
import { useQuery } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import {
  FilterParameters,
  generateFilterExpression,
  generateSortQuery,
  generateURL,
} from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { WorkspaceRecommendationsResponse } from 'types/Workspace';
import { CACHE_AND_STALE_TIME } from 'constants/index';

const getWorkspaceRecommendations = async (
  workspaceID: string | undefined | null
) => {
  if (!workspaceID) {
    Promise.reject('workspace ID not  found');
    return;
  }
  const andFilterConfig: FilterParameters[] = [
    {
      type: 'equal',
      key: 'workspaceID',
      value: workspaceID,
    },
    {
      type: 'equal',
      key: 'dismissedAt',
      value: null,
    },
  ];

  const queryArray = [
    generateSortQuery('sortOrder', 'Acs'),
    generateFilterExpression('and', andFilterConfig),
  ];

  const url = generateURL(
    SPARK_RESOURCE_TYPES.WORKSPACE_RECOMMENDATIONS,
    queryArray
  );
  return fetchWrapper<WorkspaceRecommendationsResponse>({
    url: url,
    method: 'GET',
  });
};

export function useWorkspaceRecommendations(
  workspaceID: string | undefined | null
) {
  const response = useQuery(
    ['workspaceRecommendations', workspaceID],
    () => getWorkspaceRecommendations(workspaceID),
    {
      enabled: Boolean(workspaceID),
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(
            `Failed to get workspace recommendations: ${error.message}`
          );
        }
      },
      ...CACHE_AND_STALE_TIME,
    }
  );

  const recommendations = response.data?.data;

  return {
    recommendations,
    ...response,
  };
}
